import React from 'react';
import { DeleteIcon } from '../../../Icons';
import styles from './index.module.scss';
import MenuControlButton from './MapIcons';
import Proptypes from 'prop-types';

const ClearDrawingMenu = ({ onClick }) => (
  <MenuControlButton
    title="Clear locations"
    className={styles.delete}
    component={DeleteIcon}
    onClick={onClick}
  />
);

ClearDrawingMenu.propTypes = {
  onClick: Proptypes.func,
};

export default ClearDrawingMenu;
